import React, { Fragment } from "react";

import Proptypes from "prop-types";
import alphabet from "../../../helpers/alphabet";

const AlphabetFilters = (props) => {
  return (
    <fieldset className="AlphabetFilter ListingFilters-group">
      {props.showLegend && (
        <legend className="f-label-small">Filter By Letter</legend>
      )}
      <input
        id="letter-all"
        type="radio"
        name="letter"
        value=""
        onChange={(event) => props.setLetters(event.target.value)}
        checked={props.letter === ""}
      />
      <label className="AlphabetFilter-all" htmlFor="letter-all">
        All
      </label>

      {alphabet.map((letter) => (
        <Fragment key={letter}>
          <input
            id={`letter-${letter}`}
            type="radio"
            name="letter"
            value={letter}
            disabled={!(props.activeLetters.indexOf(letter.toUpperCase()) >= 0)}
            onChange={(event) => props.setLetters(event.target.value)}
          />
          <label className="AlphabetFilter-letter" htmlFor={`letter-${letter}`}>
            {letter}
          </label>
        </Fragment>
      ))}
    </fieldset>
  );
};

AlphabetFilters.propTypes = {
  activeLetters: Proptypes.arrayOf(Proptypes.string),
  setLetters: Proptypes.func.isRequired,
  letter: Proptypes.string,
  showLegend: Proptypes.bool,
};

export default AlphabetFilters;
